module.exports = __webpack_public_path__ + "img/seal.76184307.png";